import { GlobalStyles, StyledEngineProvider } from '@mui/material';
import AOS from 'aos';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import BabciaDziadek from './components/christmas2025/BabciaDziadek';
import Intro from './components/christmas2025/Intro';
import IwoLaura from './components/christmas2025/IwoLaura';
import Tata from './components/christmas2025/Tata';
import Welcome from './components/christmas2025/Welcome';
import DzienOjca from './components/dzien-ojca/DzienOjca';
import Header from './components/Header';
import Invitation from './components/invitation/Invitation';
import MainPage from './components/MainPage';
import ProjectDisplayer from './components/ProjectDisplayer';
import { data } from './ProjectsDescription';

const TRACKING_ID1 = 'G-L5RKPQR0H9';

ReactGA.initialize(TRACKING_ID1);

export type Project = {
	title: string;
	description: string;
	media: string[];
	path: string;
	repoUrl: string;
	fullWidth: boolean;
	showcaseComponent?: React.JSX.Element;
	/**
	 * SEO overrides. Without these the <title> and meta description fall back to
	 * the markdown title/description run through toPlainText(), which truncates
	 * mid-sentence and reads poorly in search results. Prefer setting them.
	 */
	seoTitle?: string;
	seoDescription?: string;
	/** Primary language(s), surfaced in the SoftwareSourceCode JSON-LD. */
	language?: string | string[];
};

function App() {
	useEffect(() => {
		// Must run after hydration, never before: AOS stamps `aos-init` onto every
		// [data-aos] element, and if it does that to the prerendered DOM before
		// React attaches, hydration mismatches and the prerendered page is
		// discarded. This is why index.html no longer calls AOS.init() inline.
		AOS.init();
	}, []);

	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: window.location.pathname,
			title: 'Main page'
		});
	}, []);

	return (
		<HelmetProvider>
			<StyledEngineProvider enableCssLayer>
				<GlobalStyles styles="@layer theme, base, mui, components, utilities;" />

				<Router>
					<Header />
					<Routes>
						<Route path="/" element={<MainPage />} />
						<Route path="/invitation-julcia" element={<Invitation />} />
						<Route
							path="/d9b5989ea1a82edfd722cd5ffe6ba6d026ff00b369bf8ff7f332165a717c07de"
							element={<DzienOjca />}
						/>
						<Route path="/christmas-2025" element={<Intro />} />
						<Route path="/christmas-2025/content" element={<Welcome />}>
							<Route path="babcia-dziadek" element={<BabciaDziadek />} />
							<Route path="tata" element={<Tata />} />
							<Route path="laura-iwo" element={<IwoLaura />} />
						</Route>
						<Route path="/*" element={<ProjectDisplayer projects={data} />} />
					</Routes>
				</Router>
			</StyledEngineProvider>
		</HelmetProvider>
	);
}

export default App;
